import { ListRow, MutationOp, MutationOpType, ReportType } from "./types/searchTermsTrendsApi.types"

export function pickItemKey(reportType: ReportType): "searchTerm" | "categoryId" {
  return reportType === ReportType.SEARCH_TERM ? "searchTerm" : "categoryId"
}

export function rowMatchesOp(row: ListRow, op: MutationOp, reportType: ReportType): boolean {
  const key = pickItemKey(reportType)
  const target = op[key]
  if (!target) return false
  const rowKey = (row as unknown as Record<string, string>)[key]
  return rowKey === target
}

export function applyOpToRow(row: ListRow, op: MutationOp): ListRow {
  if (op.type === MutationOpType.CHANGE_STATE) {
    return { ...row, state: op.state }
  }
  if (op.type === MutationOpType.ADD_LABEL) {
    const labelIds = row.labelIds || []
    if (labelIds.includes(op.labelId)) return row
    return { ...row, labelIds: [...labelIds, op.labelId] }
  }
  if (op.type === MutationOpType.REMOVE_LABEL) {
    const labelIds = (row.labelIds || []).filter((id) => id !== op.labelId)
    return { ...row, labelIds }
  }
  return row
}

export function patchRows(rows: ListRow[], ops: MutationOp[], reportType: ReportType): ListRow[] {
  return rows.map((row) => {
    const opsForRow = ops.filter((op) => rowMatchesOp(row, op, reportType))
    if (opsForRow.length === 0) return row
    return opsForRow.reduce((acc, op) => applyOpToRow(acc, op), row)
  })
}
